<template>
  <div data-base-select>
    <multi-select
      :show-labels="false"
      :model-value="label"
      :allow-empty="true"
      :open-direction="'bottom'"
      :options="orderedOptions"
      @update:model-value="onSelect"
      :placeholder="label">
      <div class="arrow" slot="caret"></div>
      <template #noResult>
        <span>
          No results found...
        </span>
      </template>
    </multi-select>
  </div>
</template>

<script>
import vueTypes from 'vue-types'
import MultiSelect from 'vue-multiselect'

export default {
  name: 'BaseSelect',

  props: {
    options: vueTypes.array,
    label: vueTypes.string,
    id: vueTypes.any
  },

  components: {
    MultiSelect
  },

  computed: {
    orderedOptions () {
      return this.options.sort()
    }
  },

  methods: {
    onSelect (selected) {
      this.$emit('select', {
        value: selected,
        id: this.id
      })
    }
  }
}
</script>

<style lang="normal-css">
  .arrow {
    position: absolute;
    display: block;
    width: 7px;
    height: 7px;
    border-style: solid;
    border-width: 0px 1px 1px 0px;
    border-bottom-color: $ink;
    border-right-color: $ink;
    position: absolute;
    top: calc(50% - 2px);
    right: 16px;
    transform: rotate(45deg) translateY(-50%);
  }
  fieldset[disabled] .multiselect {
    pointer-events: none;
  }
  .multiselect__spinner {
    position: absolute;
    right: 1px;
    top: 1px;
    width: 48px;
    height: 35px;
    background: $white;
    display: block;
  }
  .multiselect__spinner:before,
  .multiselect__spinner:after {
    position: absolute;
    content: "";
    top: 50%;
    left: 50%;
    margin: -8px 0 0 -8px;
    width: 16px;
    height: 16px;
    border-radius: 100%;
    border-color: $green transparent transparent;
    border-style: solid;
    border-width: 2px;
    box-shadow: 0 0 0 1px transparent;
  }
  .multiselect__spinner:before {
    animation: spinning 2.4s cubic-bezier(0.41, 0.26, 0.2, 0.62);
    animation-iteration-count: infinite;
  }
  .multiselect__spinner:after {
    animation: spinning 2.4s cubic-bezier(0.51, 0.09, 0.21, 0.8);
    animation-iteration-count: infinite;
  }
  .multiselect__loading-enter-active,
  .multiselect__loading-leave-active {
    transition: opacity 0.4s ease-in-out;
    opacity: 1;
  }
  .multiselect__loading-enter,
  .multiselect__loading-leave-active {
    opacity: 0;
  }
  .multiselect,
  .multiselect__input,
  input.multiselect__input[type="text"],
  .multiselect__single {
    font-family: inherit;
    font-size: 16px;
    touch-action: manipulation;
    font-weight: 400;
    outline: none;
  }
  .multiselect {
    box-sizing: content-box;
    cursor: pointer;
    display: block;
    position: relative;
    width: 100%;
    text-align: left;
    color: $inkLighter;
    border-radius: var(--border-radius-career-filter);
  }
  .multiselect[value] .multiselect__single {
    color: $black;
  }
  .multiselect * {
    box-sizing: border-box;
  }
  .multiselect:focus,
  .multiselect:hover {
    outline: none;
  }
  .multiselect--disabled {
    pointer-events: none;
    opacity: 0.6;
  }
  .multiselect--active {
    z-index: 50;
    border-color: $skyDark;
  }
  .multiselect--active .multiselect__select {
    transform: rotateZ(180deg);
  }

  input.multiselect__input,
  .multiselect__single {
    position: relative;
    display: inline-block;
    min-height: 20px;
    line-height: 22.5px;
    border: none;
    color: $black;
    font-size: 16px;
    background: transparent;
    width: calc(100%);
    transition: border 0.1s ease;
    box-sizing: border-box;
    margin-bottom: 8px;
    vertical-align: top;
    padding: 0 0 0 5px;
  }
  input.multiselect__input {
    font-size: 16px;
    height: initial;
  }
  .multiselect__input::placeholder {
    color: $skyDark;
  }
  .multiselect__tag ~ .multiselect__input,
  .multiselect__tag ~ .multiselect__single {
    width: auto;
  }
  .multiselect__single {
    margin-bottom: 8px;
  }
  input[text].multiselect__input {
    height: initial;
  }
  .multiselect__tags-wrap {
    display: inline;
  }
  .multiselect__tags {
    line-height: 16px;
    display: block;
    padding: 6px 33px 0px 6px;
    border: none;
    border-radius: var(--border-radius-career-filter);
    background: rgba(255, 255, 255, 0.7);
    border: 1px solid rgba(0, 0, 0, 0.05);
  }
  .multiselect__tag {
    position: relative;
    display: inline-block;
    padding: 4px 26px 4px 10px;
    margin-right: 10px;
    color: $skyDark;
    line-height: 1;
    background: $skyLight;
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
  }
  .multiselect__tag-icon {
    cursor: pointer;
    margin-left: 7px;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    font-weight: 700;
    font-style: initial;
    width: 22px;
    text-align: center;
    line-height: 22px;
    transition: all 0.2s ease;
    border-radius: 5px;
  }
  .multiselect__tag-icon:after {
    content: "×";
    color: $greenDark;
  }
  .multiselect__tag-icon:focus,
  .multiselect__tag-icon:hover {
    background: $skyLight;
  }
  .multiselect__tag-icon:focus:after,
  .multiselect__tag-icon:hover:after {
    color: $white;
  }
  .multiselect__current {
    line-height: 16px;
    min-height: 40px;
    box-sizing: border-box;
    display: block;
    overflow: hidden;
    padding: 8px 12px 0;
    padding-right: 30px;
    white-space: nowrap;
    margin: 0;
    text-decoration: none;
    border: 1px solid $skyDark;
    cursor: pointer;
  }
  .multiselect__select {
    display: block;
    position: absolute;
    box-sizing: border-box;
    width: 40px;
    height: 37px;
    right: 1px;
    top: 1px;
    padding: 0px;
    margin: 0;
    text-decoration: none;
    text-align: center;
    cursor: pointer;
    transition: transform 0.2s ease;
  }
  .multiselect__select:before {
    position: relative;
    right: 0;
    top: 3px;
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    border-right: 1px solid #333;
    border-bottom: 1px solid #333;
    transform: rotate(45deg);
  }
  .multiselect__placeholder {
    color: $black;
    display: inline-block;
    margin-bottom: 10px;
    padding-top: 2px;
  }
  .multiselect--active .multiselect__placeholder {
    display: none;
  }
  .multiselect__content-wrapper {
    border-radius: 4px;
    position: absolute;
    top: calc(100% +  5px);
    display: block;
    background: $white;
    min-width: 100%;
    max-width: 300px;
    max-height: 80px;
    overflow: auto;
    border: none;
    z-index: 50;
    -webkit-overflow-scrolling: touch;
    box-shadow: 0 0.1rem 0.4rem 0.1rem rgba(0,0,0,.2);
  }
  .multiselect__content {
    list-style: none;
    display: inline-block;
    padding: 0;
    margin: 0;
    min-width: 100%;
    vertical-align: top;
    font-size: 16px;
  }
  .multiselect--above .multiselect__content-wrapper {
    bottom: 100%;
    border-top: 1px solid $skyLighter;
  }
  .multiselect__content::webkit-scrollbar {
    display: none;
  }
  .multiselect__element {
    display: block;
    border-top: 1px solid $skyLight;
  }
  .multiselect__element:first-child {
    border: none;
  }
  .multiselect__option {
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 300px;
    overflow: hidden;
    padding: 12px;
    min-height: 40px;
    line-height: 16px;
    text-decoration: none;
    text-transform: none;
    position: relative;
    cursor: pointer;
    white-space: nowrap;
    transition: background 200ms ease-out;
    font-size: 15px;
    color: $black;
  }
  .multiselect__option:hover {
    background: skyLight;
  }
  .multiselect__option:after {
    top: 0;
    right: 0;
    position: absolute;
    line-height: 40px;
    padding-right: 12px;
    padding-left: 20px;
  }
  .multiselect__option--highlight {
    background: none;
    outline: none;
  }
  .multiselect__option--highlight:after {
    content: attr(data-select);
    background: $skyLight;
  }
  .multiselect__option--selected {
    background: $skyLighter;
  }
  .multiselect__option--selected:after {
    content: attr(data-selected);
  }
  .multiselect__option--selected.multiselect__option--highlight {
    background: $skyLight;
  }
  .multiselect__option--selected.multiselect__option--highlight:after {
    background: $skyLight;
    content: attr(data-deselect);
  }
  .multiselect--disabled {
    background: $skyLighter;
    pointer-events: none;
  }
  .multiselect--disabled .multiselect__current,
  .multiselect--disabled .multiselect__select {
    background: $skyLighter;
  }
  .multiselect__option--disabled {
    background: $skyLighter;
    color: $skyDark;
    cursor: text;
    pointer-events: none;
  }
  .multiselect__option--group {
    background: $sky;
    color: $blueDark;
  }
  .multiselect__option--group.multiselect__option--highlight {
    background: $blueDark;
    color: $white;
  }
  .multiselect__option--group.multiselect__option--highlight:after {
    background: #$sky;
  }
  .multiselect__option--disabled.multiselect__option--highlight {
    background: $sky;
  }
  .multiselect__option--group-selected.multiselect__option--highlight {
    background: $sky;
  }
  .multiselect__option--group-selected.multiselect__option--highlight:after {
    background: $sky;
    content: attr(data-deselect);
  }
  .multiselect-enter-active,
  .multiselect-leave-active {
    transition: all 0.15s ease;
  }
  .multiselect-enter,
  .multiselect-leave-active {
    opacity: 0;
  }
  .multiselect__strong {
    margin-bottom: 8px;
    line-height: 20px;
    display: inline-block;
    vertical-align: top;
  }
  *[dir="rtl"] .multiselect {
    text-align: right;
  }
  *[dir="rtl"] .multiselect__select {
    right: auto;
    left: 1px;
  }
  *[dir="rtl"] .multiselect__tags {
    padding: 8px 8px 0px 40px;
  }
  *[dir="rtl"] .multiselect__content {
    text-align: right;
  }
  *[dir="rtl"] .multiselect__option:after {
    right: auto;
    left: 0;
  }
  *[dir="rtl"] .multiselect__clear {
    right: auto;
    left: 12px;
  }
  *[dir="rtl"] .multiselect__spinner {
    right: auto;
    left: 1px;
  }
  @keyframes spinning {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(2turn);
    }
  }
</style>
